  
      <app-create-charging-station-assistent (newEntityEvent)="newEntityEvent($event)" [customerId]="customerId" [hideSubmit]="true"></app-create-charging-station-assistent>
